/**
 * The browser event the API client raises on an UPGRADE_REQUIRED refusal,
 * and that a screen can raise itself to open the prompt before asking the
 * server (an "Upgrade" badge on a paid feature). detail: { feature?, cap?, message? }.
 */
export const UPGRADE_EVENT = "bp:upgrade-required";

export type UpgradeDetail = { feature?: string; cap?: string; message?: string };

export const requestUpgrade = (detail: UpgradeDetail = {}) =>
  window.dispatchEvent(new CustomEvent<UpgradeDetail>(UPGRADE_EVENT, { detail }));
